/**
 * Serializes query params as repeated keys without brackets (e.g. `type=invoice&type=warranty`),
 * which the apis read from `multiValueQueryStringParameters`. axios' default array serialization
 * (`type[]=invoice`) would not populate those, breaking the multi-value filters.
 *
 * Hand-written because the axios this app resolves is not a dependency of its own: it comes
 * transitively with aws-amplify, at 0.19, where `paramsSerializer` only takes a function. From axios
 * 1.x, `paramsSerializer: { indexes: null }` produces the same format, and this function can go once
 * axios is declared directly.
 *
 * @param {Object} params - The query parameters.
 * @returns {string} The serialized query string.
 */
export function serializeParams(params) {
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined) {
      continue
    }
    if (Array.isArray(value)) {
      value.forEach((entry) => search.append(key, entry))
    } else {
      search.append(key, value)
    }
  }
  return search.toString()
}
